import React from 'react'
import * as firebase from "firebase";


export default class Login extends React.Component {
  constructor(props) {
      super(props)
      this.checkSignedIn = this.checkSignedIn.bind(this)

  }
    componentWillMount() {
        this.checkSignedIn()
    }
    checkSignedIn(){
        var state = this
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                console.log("singed in : "+ user.phoneNumber);
               // state.setState({isLoggedIn:true});
            }else {
                console.log("singed out  ");
               // state.setState({isLoggedIn:false});

            }
        });
    }
  render() {

    return <div id="content">

        <div id="home_image_container">
            <image id ="image_home"src="https://lh3.googleusercontent.com/NROgq4J5D7UwxFO4jgc2Gb_MaSmbZUA0oLpkSr9AiqBwUOwv1j_3WjCWiPCgzoOTZA=h900-rw"></image>
        </div>
        <div id="play_store_container" >
            <a href='https://play.google.com/store/apps/details?id=us.mordor.AndroidMessenger&utm_source=www.texerapp.org&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img id="play_store_img"alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png'/></a>
        </div>
    </div>

  }
}




// WEBPACK FOOTER //
// ./src/components/pages/Home.jsx